import { useEffect, useCallback } from "react";
import { Menu } from "antd";
import { useRequest } from "ahooks";
import { department as departmentService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function DepartmentType({ departmentType, setDepartmentType }) {
  const auth = useAuthContext();
  const clickHandler = useCallback(
    (value) => {
      setDepartmentType(value);
    },
    [setDepartmentType]
  );

  const { data = [], run } = useRequest(
    (params, token) => departmentService.listType(params, token),
    {
      manual: true,
    }
  );
  useEffect(() => {
    if (auth) {
      const type = auth.roles === "admin" ? 1 : 2;
      run({ type }, auth.token);
    }
  }, [run, auth]);
  const menuItems = data.map((menu) => (
    <Menu.Item
      key={`department-type-${menu.id}`}
      onClick={() => clickHandler(menu.id)}
    >
      {menu.name}
    </Menu.Item>
  ));
  return (
    <Menu defaultSelectedKeys={[`department-type-${departmentType}`]}>
      <Menu.Item
        key={`department-type-all`}
        onClick={() => clickHandler("all")}
      >
        全部
      </Menu.Item>
      {menuItems}
    </Menu>
  );
}

export default DepartmentType;
